export default __webpack_public_path__ + "static/media/ecommerce-1.fcdebcac.png";